import {useQuery} from '@tanstack/react-query';
import {ApiError} from '@pocketbuy/outdoor-api-client';
import type {PickupEligibility} from '@pocketbuy/outdoor-business-types';
import {pickupApi} from '../../api';
import {useSession} from '../../session';

export function usePickupEligibility(refetchInterval=30000) {
  const session=useSession(s=>s.session);
  return useQuery({
    queryKey:['pickup-eligibility',session?.accessToken], queryFn:pickupApi.eligibility,
    enabled:session?.activeRole==='SALES_AGENT', staleTime:0, refetchInterval, retry:false,
  });
}

export function overduePickupFailure(error:unknown):PickupEligibility|undefined {
  if(error instanceof ApiError && error.code==='PICKUP_OVERDUE_PHONES') {
    const data=error.data as PickupEligibility|undefined;
    if(data?.allowed===false && data.overdueCount>0 && Array.isArray(data.overduePhones))return data;
  }
}
